import { useEffect, useState } from "react";
import { getFishingOutlookBetaAccess } from "./fishingOutlookAccessApi";

export const FISHING_OUTLOOK_ACCESS_STATE = Object.freeze({
  LOADING: "loading",
  AUTHORIZED: "authorized",
  UNAUTHORIZED: "unauthorized",
});

export default function useFishingOutlookBetaAccess(userId) {
  const normalizedUserId = String(userId || "").trim();
  const [result, setResult] = useState({
    ownerId: "",
    state: FISHING_OUTLOOK_ACCESS_STATE.LOADING,
  });

  useEffect(() => {
    if (!normalizedUserId || typeof window === "undefined") {
      setResult({
        ownerId: normalizedUserId,
        state: FISHING_OUTLOOK_ACCESS_STATE.UNAUTHORIZED,
      });
      return undefined;
    }

    const controller = new AbortController();
    setResult({
      ownerId: normalizedUserId,
      state: FISHING_OUTLOOK_ACCESS_STATE.LOADING,
    });

    getFishingOutlookBetaAccess({ signal: controller.signal })
      .then((payload) => {
        if (controller.signal.aborted) return;
        setResult({
          ownerId: normalizedUserId,
          state:
            payload?.canAccess === true
              ? FISHING_OUTLOOK_ACCESS_STATE.AUTHORIZED
              : FISHING_OUTLOOK_ACCESS_STATE.UNAUTHORIZED,
        });
      })
      .catch(() => {
        if (controller.signal.aborted) return;
        setResult({
          ownerId: normalizedUserId,
          state: FISHING_OUTLOOK_ACCESS_STATE.UNAUTHORIZED,
        });
      });

    return () => controller.abort();
  }, [normalizedUserId]);

  if (result.ownerId !== normalizedUserId) {
    return normalizedUserId
      ? FISHING_OUTLOOK_ACCESS_STATE.LOADING
      : FISHING_OUTLOOK_ACCESS_STATE.UNAUTHORIZED;
  }

  return result.state;
}
